module.exports = __webpack_public_path__ + "static/media/school.e24b45c6.svg";